// Import React
import React from 'react';

// Import dependencies
import ReactDOM from 'react-dom/client';
import atatus from "atatus-spa";

// import { createHistory, useBasename } from 'history';


// Import styles
import '../public/static/css/screen.css';


// Import stores
import store from './app/stores/';
import AppRouter from "./app/routes";
//const history = syncHistoryWithStore(hashHistory, routingStore);

atatus.config('7bab4b9172ba4a0bbdf9cdcd710de4d8', {
  console: true,
  consoleTimeline: true,
  customData: JSON.parse(sessionStorage.getItem('userData'))
}).install();

// Add the user agent as an attribute on the document
const ua = navigator.userAgent;
document.querySelector('html').setAttribute('data-ua', ua);

// Flag IE 10
if(ua.indexOf('MSIE 10.0') > -1) {
  document.querySelector('html').className += ' ie-true lt-ie11'
}

// Flag IE 11
if(!!window.MSInputMethodContext && !!document.documentMode) {
  document.querySelector('html').className += ' ie-true'
}

// Aids with button focus styles
document.querySelector('body').addEventListener('click', function(e){
  if(e.target.className && typeof e.target.className === 'string') {
    if(
        e.target.className.indexOf('btn') > -1 ||
        e.target.className.indexOf('calendar__nav') > -1
    ) {
      e.target.className += ' btn-clicked';

      e.target.addEventListener('blur', function(e){
        e.target.className = e.target.className.replace('btn-clicked', '');
      })
    }
  }
});

// Track pageviews
/*
let gaTimeout = null;

/*history.listen(location => {
  // Track on route change
  if(window.ga) {
    trackPageview(location.pathname + location.search);
  }
});

// Track on initial load
trackPageview(history.getCurrentLocation().pathname + history.getCurrentLocation().search);
function sanitizeUrl(url) {
  // Make sure there’s a leading slash
  if(url.charAt(0) !== '/') {
    url = `/${url}`;
  }

  // Replace sid segments with placeholders
  if(url.indexOf('/sessions/ES') > -1) {
    // Session sid
    url = url.replace(/(\/sessions\/)\w+/, '$1{sessionSid}');
  }

  if(url.indexOf('/view/MT') > -1) {
    // View message thread sid
    url = url.replace(/(\/view\/)\w+/, '$1{messageThreadSid}');
  }

  if(url.indexOf('/detail/MT') > -1) {
    // View message thread sid
    url = url.replace(/(\/detail\/)\w+/, '$1{messageThreadSid}');
  }

  if(url.indexOf('/view/ST') > -1) {
    // View support ticket sid
    url = url.replace(/(\/view\/)\w+/, '$1{supportTicketSid}');
  }

  if(url.indexOf('/edit/PL') > -1) {
    // Edit location sid
    url = url.replace(/(\/edit\/)\w+/, '$1{locationSid}');
  }

  return url;
}

function trackPageview(url) {
  if(url.indexOf('?token=') > -1) {
    url='/';
  }

  // Wait until GA function is available
  const gaDelay = setInterval(function(){
    if(window.ga) {
      clearInterval(gaDelay);

      // Make sure we don't send the event multiple times
      gaTimeout = setTimeout(function(){
        clearTimeout(gaTimeout);
        const cleanUrl = sanitizeUrl(url);
        window.ga('send', 'pageview', cleanUrl);
      }, 500);
    }
  }, 100);
}*/

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<AppRouter store={store}></AppRouter>)


// WEBPACK FOOTER //
// ./src/index.js